module.exports = __webpack_public_path__ + "img/yakitori1.f6e4517f.png";